class GallerySlider extends HTMLElement {
    constructor() {
        super();

        this.wrapper_slider = this.querySelector('.slider-project');

        this.modalSlide = this.querySelector('.modal');
        this.closeModal = this.querySelector('.close-modal');

        this.sliderModal;
    }

    connectedCallback() {
        tns({
            container: this.wrapper_slider,
            mouseDrag: true,
            controlsContainer: this.querySelector('.container-arrows-project'),
            autoWidth: true,
            gutter: 20,
            responsive: {
                320: {
                    items: 1,
                },
                560: {
                    items: 2,
                },
                768: {
                    items: 2.5,
                }
            },
        });

        this.slides = this.querySelectorAll('[data-slide-target]');
        // this.slideContents = this.querySelectorAll('.[data-slide-content]');

        this.slides.forEach(elm => elm.addEventListener('click', this.onLogoClick.bind(this)));
        this.closeModal.addEventListener('click', this.onCloseModal.bind(this));
    }

    onCloseModal(evnt) {
        evnt.preventDefault();
        this.modalSlide.classList.remove('active-modal');
        this.sliderModal.destroy();
    }

    onLogoClick(evtn) {
        evtn.preventDefault();

        this.slideIndex = evtn.currentTarget.dataset.slideIndex;

        this.sliderModal = tns({
            "container": this.querySelector(".modal-content"),
            "items": 1,
            "swipeAngle": false,
            "speed": 800,
            "startIndex": this.slideIndex,
            "controlsText": [' ', ' '],
            "mouseDrag": true,
            "responsive": {
                830: {
                    "fixedWith": true
                }
            }
        });
        this.sliderModal;

        this.modalSlide.classList.add('active-modal');
    }
}

customElements.define('gallery-projects', GallerySlider);